const $ = require('jquery');

/**
 * Track the event when the customer reachs the shipping page after clicking on the button
 * of the Optimizely experiment MOBILE_CART_PROCEED_TO_CHECKOUT
 */
function trackEventShipping() {
    const isCOReachedWithOptiStickyButton = window.sessionStorage.getItem('isCOReachedWithOptiStickyButton');
    if ($('.checkout-shipping-address').length && isCOReachedWithOptiStickyButton) {
        const optiExperiment = require('../optimizelyExperimentation');
        optiExperiment.trackEvent('checkout_page_1_reach');
        window.sessionStorage.setItem('isCOReachedWithOptiStickyButton', '0');
    }
}

module.exports = {
    /**
     *
     */
    init() {
        trackEventShipping();
    }
};
